import { Controller } from "@hotwired/stimulus";
import { jquery } from 'utils/jquery';

export default class extends Controller {
    connect() {
        const $ = jquery();
        if (!$) {
            return;
        }

        $('body').css('overflow', 'auto !important'); // recalculate scroll after turbo update
    }
}